'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconPaperPlane, iconPaperPlaneTag } from '@ni/nimble-components/dist/esm/icons/paper-plane';
import { wrap } from '../../utilities/react-wrapper';

export type { IconPaperPlane };
export { iconPaperPlaneTag };
export const NimbleIconPaperPlane = wrap(IconPaperPlane);